module.exports = __webpack_public_path__ + "img/1536497468.e2e3ea31.jpg";